import 'whatwg-fetch';
import es6Promise from 'es6-promise';
import {debounce} from 'lodash';

es6Promise.polyfill();

export class WebHeader {
  constructor() {
    try {
      const data = document.getElementById('sukima-web-header-data').dataset;
    } catch (e) {
      return;
    }
    this.menuIsShow = false;
    this.searchIsShow = false;
    this.suggestList = null;
    this.isSmartphone = data.is_smartphone ? JSON.parse(data.is_smartphone) : false;
    this.isActive = data.is_active ? JSON.parse(data.is_active) : false;
    this.searchWord = data.searchword ? data.searchword : '';

    this.bodyLogo = document.getElementById('header-body-logo');
    this.bodySearch = document.getElementById('header-body-search');
    this.bodyMenu = document.getElementById('header-body-menu');
    this.bodyMenuLogin = document.getElementById('header-body-menu-login');
    this.formWrapper = document.getElementById('header-body-form-wrapper');
    this.form = document.getElementById('header-body-form');
    this.formButton = document.getElementById('header-body-form-button');
    this.formInput = document.getElementById('header-body-form-input');
    this.backGround = document.getElementById('header-background');
    this.search = document.getElementById('header-search');
    this.searchPopular = document.getElementById('header-search-popular');
    this.searchLoadSuggest = document.getElementById('header-search-load-suggest');
    this.searchSuggest = document.getElementById('header-search-suggest');
    this.searchNoSuggest = document.getElementById('header-search-no-suggest');
    this.searchSuggestTemplate = document.getElementById('header-search-suggest-template');
    this.menu = document.getElementById('header-menu');
    this.menuLogout = document.getElementById('header-menu-logout');
    this.headNav = document.getElementById('header-navi');

    // 検索キーワードがジャンル名と一致している場合はキーワードを初期化する
    if (['少年漫画', '少女漫画', '青年漫画', '女性漫画', 'TL(ティーンズラブ)', 'BL(ボーイズラブ)'].indexOf(this.searchWord) !== -1) {
      this.searchWord = null;
      this.formInput.value = null;
    }
  }

  initialize() {
    try {
      this.form.onsubmit = this.onSubmit.bind(this);
    } catch (e) {
      return;
    }
    this.formInput.oninput = debounce(this.onInput.bind(this), 300);
    this.bodySearch.onclick = this.onClickSearch.bind(this);
    if (this.bodyMenu) {
      this.bodyMenu.onclick = this.onClickMenu.bind(this);
    }
    if (this.backGround) {
      this.backGround.onclick = this.onClickBackGround.bind(this);
    }
    if (this.menuLogout) {
      this.menuLogout.onclick = this.onClickLogout.bind(this);
    }

    this.formInput.onkeydown = this.onKeyDown.bind(this);
    if (this.searchPopular) {
      this.searchPopular.onkeydown = this.onKeyDown.bind(this);
    }
    if (this.searchSuggest) {
      this.searchSuggest.onkeydown = this.onKeyDown.bind(this);
    }
  }

  onSubmit() {
    // 検索キーワードが空の場合は検索しない
    if (this.searchWord) {
      this.form.submit();
    }
  }

  onInput(event) {
    this.searchWord = event.target.value;
    this.toggleSearch();
    if (this.searchWord) {
      fetch(`/api/search/suggest/?word=${this.searchWord}`, {
        method: 'GET',
        mode: 'same-origin',
        credentials: 'same-origin',
      }).then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('response is not json.');
      }).then((json) => {
        if (json.is_success) {
          return json.result;
        }
        throw new Error('response is not success.');
      }).then(result => result.map((r) => {
        r.title_name = this.formatResult(r.title_name);
        r.author = this.formatResult(r.author);
        return r;
      })).then((result) => {
        this.suggestList = result;
        this.toggleSearch();
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  onKeyDown(event) {
    const keyName = event.key;
    const target = event.target;

    if (target.tagName === 'INPUT') {
      if (keyName == 'ArrowDown') {
        let children = this.searchWord ? this.searchSuggest.children : this.searchPopular.children;
        Array.from(children).some((node) => {
          if (node.tagName === 'A') {
            node.focus();
          }
          ;
          return (node.tagName === 'A')
        });
        event.preventDefault();
      }
    } else {
      if (keyName == 'ArrowDown') {
        const next = target.nextElementSibling;
        if (next && next.tagName === 'A') {
          next.focus();
        }
        event.preventDefault();
      }
      if (keyName == 'ArrowUp') {
        const prev = target.previousElementSibling;
        if (prev && prev.tagName === 'A') {
          prev.focus();
        } else {
          this.formInput.focus();
        }
        event.preventDefault();
      }
    }
  }

  onClickBackGround() {
    this.searchIsShow = false;
    this.menuIsShow = false;
    this.blockBody();
    this.toggleBody();
  }

  onClickSearch() {
    this.searchIsShow = !this.searchIsShow;
    this.menuIsShow = false;
    this.blockBody();
    this.toggleBody();
    if (this.searchIsShow) {
      sendEvent('ヘッダー検索', '展開する');
    }
  }

  onClickMenu() {
    this.menuIsShow = !this.menuIsShow;
    this.searchIsShow = false;
    this.blockBody();
    this.toggleBody();
    if (this.menuIsShow) {
      sendEvent('ハンバーガー', '展開する');
    }
  }

  onClickLogout() {
    // logout modal表示
    // globalのjQueryを使っている
    $('#logout-modal').modal();
  }

  formatResult(suggestion) {
    if (!this.searchWord) {
      return suggestion;
    }
    return suggestion
      .replace(new RegExp(`(${this.searchWord.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')})`, 'gi'), '<strong>$1<\/strong>')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
  }

  blockBody() {
    if (this.isSmartphone) {
      if (this.menuIsShow || this.searchIsShow) {
        window._.blockBody();
      } else {
        window._.releaseBody();
      }
    }
  }

  toggleBody() {
    if (this.searchIsShow) {
      if (this.isSmartphone) {
        this.bodyLogo.classList.add('header-hidden');
      }
      this.formWrapper.classList.remove('header-hidden');
      this.bodySearch.classList.remove('icon-search');
      this.bodySearch.classList.add('icon-cancel');
      if (this.bodyMenu) {
        this.bodyMenu.classList.add('header-hidden');
      }
      if (this.bodyMenuLogin) {
        this.bodyMenuLogin.classList.add('header-hidden');
      }
      this.search.classList.remove('header-hidden');
      this.search.classList.remove(`header-search--${this.isSmartphone ? 'SP' : 'PC'}--hide`);
      this.search.classList.add(`header-search--${this.isSmartphone ? 'SP' : 'PC'}--show`);

      // text inputにフォーカス
      if (!this.isSmartphone) {
        try {
          this.formInput.focus();
        } catch (e) {
        }
      }
    } else {
      if (this.isSmartphone) {
        this.bodyLogo.classList.remove('header-hidden');
      }
      this.formWrapper.classList.add('header-hidden');
      this.bodySearch.classList.remove('icon-cancel');
      this.bodySearch.classList.add('icon-search');
      if (this.bodyMenu) {
        this.bodyMenu.classList.remove('header-hidden');
      }
      if (this.bodyMenuLogin) {
        this.bodyMenuLogin.classList.remove('header-hidden');
      }
      window.setTimeout(() => {
        this.search.classList.add('header-hidden');
      }, 200);
      this.search.classList.remove(`header-search--${this.isSmartphone ? 'SP' : 'PC'}--show`);
      this.search.classList.add(`header-search--${this.isSmartphone ? 'SP' : 'PC'}--hide`);
    }

    if (this.menuIsShow) {
      if (this.bodyMenu) {
        this.bodyMenu.classList.remove('icon-menu');
        this.bodyMenu.classList.add('icon-close');
      }
      if (this.menu) {
        this.menu.classList.remove('header-hidden');
        this.menu.classList.remove(`header-menu--${this.isSmartphone ? 'SP' : 'PC'}--hide`);
        this.menu.classList.add(`header-menu--${this.isSmartphone ? 'SP' : 'PC'}--show`);
      }
    } else {
      if (this.bodyMenu) {
        this.bodyMenu.classList.remove('icon-close');
        this.bodyMenu.classList.add('icon-menu');
      }
      if (this.menu) {
        window.setTimeout(() => {
          this.menu.classList.add('header-hidden');
        }, 200);
        this.menu.classList.remove(`header-menu--${this.isSmartphone ? 'SP' : 'PC'}--show`);
        this.menu.classList.add(`header-menu--${this.isSmartphone ? 'SP' : 'PC'}--hide`);
      }
    }

    if (this.backGround) {
      if (this.searchIsShow || this.menuIsShow) {
        this.backGround.classList.remove('header-hidden');
      } else {
        this.backGround.classList.add('header-hidden');
      }
    }
    if (this.isSmartphone && this.menuIsShow || this.isSmartphone && this.searchIsShow) {
      this.headNav.classList.add('header-navi--hidden');
    } else {
      this.headNav.classList.remove('header-navi--hidden');
    }
  }

  toggleSearch() {
    if (this.searchWord === null || this.searchWord === '') {
      this.searchPopular.classList.remove('header-hidden');
      this.searchLoadSuggest.classList.add('header-hidden');
      this.searchSuggest.classList.add('header-hidden');
      this.searchNoSuggest.classList.add('header-hidden');

    } else if (this.suggestList === null) {
      this.searchPopular.classList.add('header-hidden');
      this.searchLoadSuggest.classList.remove('header-hidden');
      this.searchSuggest.classList.add('header-hidden');
      this.searchNoSuggest.classList.add('header-hidden');

    } else if (this.suggestList.length > 0) {
      this.searchLoadSuggest.classList.add('header-hidden');
      this.searchPopular.classList.add('header-hidden');
      this.searchSuggest.classList.remove('header-hidden');
      this.searchNoSuggest.classList.add('header-hidden');

      // 既存の検索結果を削除
      while (this.searchSuggest.firstChild) {
        this.searchSuggest.removeChild(this.searchSuggest.firstChild);
      }

      if ('content' in document.createElement('template')) {
        // template element使えるかチェック
        this.suggestList.forEach((data) => {
          let clone = document.importNode(this.searchSuggestTemplate.content, true);
          let cloneChild = clone.firstElementChild;
          cloneChild.setAttribute('href', `/book/title/${data.title_code}/`);
          let thumbElement = document.createElement('img');
          thumbElement.setAttribute('src', data.thumbnail_image_path);
          thumbElement.classList.add('img-fluid');
          cloneChild.firstElementChild.appendChild(thumbElement);
          cloneChild.lastElementChild.firstElementChild.innerHTML = data.title_name;
          cloneChild.lastElementChild.lastElementChild.innerHTML = data.author;
          this.searchSuggest.appendChild(clone);
        });
      } else {
        // IEの場合
        this.suggestList.forEach((data) => {
          const aTag = document.createElement('a');
          const titleNameDiv = document.createElement('div');
          const authorDiv = document.createElement('div');
          aTag.classList.add('header-search__suggest');
          aTag.setAttribute('href', `/book/title/${data.title_code}/`);
          titleNameDiv.classList.add('header-search__suggest__info__titlename');
          titleNameDiv.innerHTML = data.title_name;
          authorDiv.classList.add('header-search__suggest__info__author');
          authorDiv.innerHTML = data.author;
          aTag.appendChild(titleNameDiv);
          aTag.appendChild(authorDiv);
          this.searchSuggest.appendChild(aTag);
        });
      }

    } else {
      this.searchPopular.classList.add('header-hidden');
      this.searchLoadSuggest.classList.add('header-hidden');
      this.searchSuggest.classList.add('header-hidden');
      this.searchNoSuggest.classList.remove('header-hidden');
    }
  }

  static init() {
    if (initialized) {
      return;
    }
    initialized = true;
    const webHeader = new WebHeader();
    webHeader.initialize();
    window.webHeader = webHeader
  }
}

var initialized = false;

window.onload = WebHeader.init;

